import { leasePaymentType,agentTypeList } from '@/util/dictList.js'
import store from "@/store";
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  rowKey: 'index',
  column: [
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      search: true,
      searchOrder: 990,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      search: true,
      searchOrder: 999,
      hide: true,
      filterable: true,
      searchMultiple: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'cascader',
      dicData: store.getters.porductCascader,
      searchCheckStrictly:true,
      // searchMultiple: true,
      hide: true,
      search: true,
      searchOrder: 998,
      cascader: ['lendingRate'],
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      display: false,
      search: true,
      searchOrder: 997,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      span: 24,
      search: true,
      searchOrder: 996,
      display: false,
    },
    {
      label: '产品类型',
      width: 90,
      prop: 'rentTypeName',
      // dicData: store.getters.porductTypes,
    },
    {
      label: '租付类型',
      prop: 'loanBeforePay',
      span: 24,
      display: false,
      search: true,
      searchOrder: 993,
      type: 'select',
      dicData:leasePaymentType
    },
    {
      label: '租率',
      prop: 'lendingRate',
      span: 24,
      display: false,
      // search: true,
      searchOrder: 994,
      formatter: (val, value, label) => {
        return value ? value + '%' : '';
      },
    },
    {
      label: '租期',
      prop: 'tenancy',
      span: 24,
      display: false,
      // search: true,
      searchOrder: 995,
      formatter: (val, value, label) => {
        return value ? value + '期' : '';
      },
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '每期租金',
      prop: 'lendingAmountPer',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '返佣比例',
      prop: 'rakeBackRate',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '返佣金额',
      prop: 'rakeBackMoney',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '平台',
      prop: 'platformName',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '所属代理商',
      prop: 'deptName',
      span: 24,
      minWidth:90,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '代理商类型',
      prop: 'agentType',
      minWidth:90,
      span: 24,
      display: false,
      searchOrder: 1000,
      dicData:agentTypeList
    },
    {
      label: '申请人',
      prop: 'applyUser',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '申请时间',
      prop: 'applyTime',
      span: 24,
      display: false,
    },
  ],
};

//根据角色权限来展示
export const jurisdictionDifferentiate = {
  finance: [
    {
      title: '租赁人',
      value: 'name',
      order: 1,
    },
    {
      title: '车牌号',
      value: 'carFirstNumber',
      order: 2,
    },
    {
      title: '所属代理商',
      value: 'deptName',
      order: 3,
    },
    {
      title: '代理商类型',
      value: 'agentType',
      order: 4,
    },
    {
      title: '产品类型',
      value: 'rentTypeName',
      order: 5,
    },
    {
      title: '租付类型',
      value: 'loanBeforePay',
      order: 6,
    },
    {
      title: '租率',
      value: 'lendingRate',
      order: 7,
    },
    {
      title: '租赁金额',
      value: 'lendingAmount',
      order: 8,
    },
    {
      title: '每期租金',
      value: 'lendingAmountPer',
      order: 9,
    },
    {
      title: '返佣比例',
      value: 'rakeBackRate',
      order: 10,
    },
    {
      title: '返佣金额',
      value: 'rakeBackMoney',
      order: 11,
    },
  ],
};
